import { Injectable } from '@angular/core';

const SEARCH_TERM: string = '{{#eachTable';

@Injectable({
  providedIn: 'root'
})
export class HandlebarsService {
  constructor() {}

  insertHandlebars(htmlString: string): string {
    const searchIndex: number = htmlString.indexOf(SEARCH_TERM);

    if (searchIndex === -1) return htmlString;

    const handlebarTerm: string = this.handlebarTerm(searchIndex, htmlString);
    const insertOpenIndex = htmlString.lastIndexOf('<tr>', searchIndex);

    const firstPartString: string = htmlString.substring(0, insertOpenIndex);

    const insertCloseIndex = htmlString
      .substring(insertOpenIndex)
      .indexOf('</tr>');

    const secondPartString: string =
      htmlString
        .substring(insertOpenIndex)
        .substring(0, insertCloseIndex + '</tr>'.length) +
      '{{/each}}' +
      this.insertHandlebars(
        htmlString
          .substring(insertOpenIndex)
          .substring(insertCloseIndex + '</tr>'.length)
      );

    return firstPartString + `{{#each ${handlebarTerm}}}` + secondPartString;
  }

  private handlebarTerm(searchIndex: number, htmlString: string): string {
    const firstDivisorIndex: number = searchIndex + 13;
    const divisorIndex: number = htmlString
      .substring(firstDivisorIndex)
      .indexOf('}}');
    const handlebarTerm: string = htmlString.substring(
      firstDivisorIndex,
      firstDivisorIndex + divisorIndex
    );
    return handlebarTerm;
  }
}
